<template>
    <ModalComponent
        :name="'editar-' + frecuencia.id"
        title='Editar frecuencia'
        v-on:close="() => close(false)"
        v-if="!loading"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormFrecuencia :frecuencia="frecuencia" @terminado="editar"/>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
    <LoaderComponent v-else/>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormFrecuencia from '@/components/backend/bases/categorias/frecuencias/FormFrecuencia';

    export default {
        props: ['frecuencia', 'lista_id'],
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            close() {                
                this.$emit('close', 'editar-' + this.frecuencia.id);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editar();
                }
            },
            editar() {
                this.loading = true;

                var params = {
                    filters : {},
                    frecuencia: this.frecuencia.frecuencia,
                    cantidad: this.frecuencia.cantidad,
                    frecuencia_id: this.frecuencia.id,
                    lista_id: this.lista_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.frecuencias.editar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message, {});
                    this.close();
                }).finally(() => this.loading = false);
            },
        },
        components: {
            ModalComponent, FormFrecuencia
        }
    }
</script>
